import { redirect } from 'redux-first-router';
import routes from '../../../routes.global';
import { GO_LOGIN } from '../../../../store/actions/auth.types';
import viewNames from '../../../../store/actions/view.types';

import * as types from '../../../../store/actions/users.types';

// ------------------------------------
// Actions
// ------------------------------------

export const loadPaymentInformation = () => async (dispatch, getState, { api }) => {
  const { payment_information: paymentInformation } = await api.user.getPaymentInformation();
  return dispatch({
    type: types.USER_GET_PAYMENT_INFORMATION,
    payload: paymentInformation,
  });
};


// ------------------------------------
// View / Route
// ------------------------------------
export const PAYMENT_INFORMATION_VIEW = 'PAYMENT_INFORMATION_VIEW';

viewNames[PAYMENT_INFORMATION_VIEW] = 'myhuddle/PaymentInformation';
routes[PAYMENT_INFORMATION_VIEW] = {
  path: '/myhuddle/subscription-status',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    // console.log(loggedIn);
    if (!loggedIn) {
      await dispatch(redirect({ type: GO_LOGIN }));
    } else await dispatch(loadPaymentInformation());
  },
};


export const RENEW_SUBSCRIPTION_VIEW = 'RENEW_SUBSCRIPTION_VIEW';

viewNames[RENEW_SUBSCRIPTION_VIEW] = 'myhuddle/RenewSubscription';
routes[RENEW_SUBSCRIPTION_VIEW] = {
  path: '/myhuddle/renew-subscription',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    if (!loggedIn) {
      await dispatch(redirect({ type: GO_LOGIN }));
    }
  },
};

export const redirectRenewal = () => async dispatch => {
  await dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
};



// WEBPACK FOOTER //
// ./src/app/views/PaymentInformation/module/index.js